var React = require('react');

function IconCaret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50 24.6l50 50.8H0z"}));
}

IconCaret.defaultProps = {"className":"icon caret","viewBox":"0 0 100 100"};

module.exports = IconCaret;

IconCaret.default = IconCaret;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-caret.svg
// module id = 531
// module chunks = 0